import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchAll,fetchById,activateById,inactivateById,register,save,aereoAPI } from './houseAPI';
import { CONSULT_MODE, CREATE_MODE, NONE_MODE, UPDATE_MODE } from '../mode';
import { ALTERNATIVE_LOADING_STATUS, FAILURE_STATUS, IDLE_STATUS, LOADING_STATUS, SUCCESS_STATUS } from '../status';
import i18n from '../../i18n';

const initialState = {
    status: IDLE_STATUS,
    mode: {
        main: NONE_MODE,
    },
    error: null,
    response: {
      status: null,
      message: null,
      data: null,
    },
    list: [],
    type: null,
    operation: "IMPORTACAO",
    model: {
      id: undefined,
      code: undefined,
      description: undefined,
      numeroProcesso:null,
      cliente : {
        id : null,
      },
      servico : {
        id : null,
      },
      tarifa : {
        id : null,
      },
      tabelaFrete : {
        id: null,
      },
      origim: {
        id : null,
      },
      destino: {
        id : null,
      },
      tipoEmbarque : null,
      cargaPerigosa : null,
      incotermVenda : {
        id : null,
      },
      aeroportoDesembarque : {
        id : null,
      },
      numeroVooViagem : null,
      aeroportoEmbarque : {
        id : null,
      },
      active: undefined,
      insertionDate: undefined,
      volumes:[],
      custos: [],
      ncms: [],
      usuario : undefined,
      embarcacao : undefined,
      transportadorInternacional: undefined,
      numero_voo_viagem : undefined,
    },
}

const fetchAllAsync = createAsyncThunk('house/fetchAll', async (params) => {
    const { data } = await fetchAll(params);
    return { data };
});

const fetchByIdAsync = createAsyncThunk('house/fetchById', async (data) => {
    const response = await fetchById(data);
    return {
        response: {
            status: response.status,
            data: response.data,
          },
    };
});

const activateByIdAsync = createAsyncThunk('house/activateById', async (id) => {
    const { status, data } = await activateById(id);
    return { response: { status, data } };
});

const inactivateByIdAsync = createAsyncThunk('house/inactivateById',async (id) => {
    const { status, data } = await inactivateById(id);
    return { response: { status, data } };
  }
);

const houseSlice = createSlice({
    name: 'house',
    initialState,
    reducers: {
      changeStatusTo: (state, action) => {
        state.status = action.payload.status;
      },
      loading: (state) => {
        state.status = LOADING_STATUS;
      },
      success: (state) => {
        state.status = SUCCESS_STATUS;
      },
      failure: (state) => {
        state.status = FAILURE_STATUS;
      },
      resetStatus: (state) => {
        state.status = IDLE_STATUS;
      },
      changeModeTo: (state, action) => {
        state.mode.main = action.payload;
      },
      changeToCreateMode: (state) => {
        state.mode.main = CREATE_MODE;
      },
      changeToConsultMode: (state) => {
        state.mode.main = CONSULT_MODE;
      },
      changeToUpdateMode: (state) => {
        state.mode.main = UPDATE_MODE;
      },
      setOperationImportacao: (state) => {
        state.operation = "IMPORTACAO";
      },
      setOperationExportacao: (state) => {
        state.operation = "EXPORTACAO";
      },
      setHouseHblType: (state) => {
        state.type = "HBL";
      },
      setHouseHawbType: (state) => {
        state.type = "HAWB";
      },
      resetHouseType: (state) => {
        state.type = null;
      },
      resetMode: (state) => {
        state.mode.main = NONE_MODE;
      },
      setModel: (state, action) => {
        state.model = {
          ...action.payload,
        };
      },
      resetModel: (state) => {
        state.model = initialState.model;
      },
      addToList: (state, action) => {
        state.list = [...state.list, action.payload.data];
      },
      updateOnList: (state, action) => {
        state.list = state.list.map((current) => {
          if (current.id === action.payload.data?.id) {
            return action.payload.data;
          }
          return current;
        });
      },
      resetList: (state) => {
        state.list = [];
      },
      setList: (state, action) => {
        state.list = action.payload.data;
      },
      setResponse: (state, action) => {
        state.response = action.payload;
      },
      clearResponse: (state) => {
        state.response = {
          status: null,
          message: null,
          data: null,
        };
      },
      setError: (state, action) => {
        state.error = action.payload;
      },
      clearError: (state) => {
        state.error = initialState.error;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAllAsync.pending, (state) => {
          state.status = ALTERNATIVE_LOADING_STATUS;
        })
        .addCase(fetchAllAsync.fulfilled, (state, action) => {
          state.status = IDLE_STATUS;
          state.list = action.payload.data;
        })
        .addCase(fetchAllAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroCarregarListaDespesaReceita', { erro: action.error.message }),
          };
        })
        .addCase(fetchByIdAsync.pending, (state) => {
          state.status = LOADING_STATUS;
        })
        .addCase(fetchByIdAsync.fulfilled, (state, action) => {
          if (action.payload.response.status === 200) {
            state.model = {
              ...action.payload.response.data,
            };
            state.status = SUCCESS_STATUS;
          }
        })
        .addCase(fetchByIdAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroCarregarDespesaReceita', { erro: action.error.message }),
          };
        })
        .addCase(activateByIdAsync.pending, (state) => {
          state.status = LOADING_STATUS;
        })
        .addCase(activateByIdAsync.fulfilled, (state, action) => {
          state.status = SUCCESS_STATUS;
          state.response.status = action.payload.response.status;
          state.response.data = action.payload.response.data;
  
          const { description  } = action.payload.response.data;
  
          state.response.message = i18n.t('com.muralis.qcx.mensagem.despesaReceitaAtivada', {
            receitaDespesa: '',
            description,
          });
  
          if (state.response.status === 200) {
            state.list = state.list.map((current) =>
              current.id === action.payload.response.data.id ? action.payload.response.data : current
            );
          }
        })
        .addCase(activateByIdAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroAtivarDespesaReceita', { erro: action.error.message }),
          };
        })
        .addCase(inactivateByIdAsync.pending, (state) => {
          state.status = LOADING_STATUS;
        })
        .addCase(inactivateByIdAsync.fulfilled, (state, action) => {
          state.status = SUCCESS_STATUS;
          state.response.status = action.payload.response.status;
          state.response.data = action.payload.response.data;
  
          const { description } = action.payload.response.data;

          state.response.message = i18n.t('com.muralis.qcx.mensagem.DespesaReceitaInativada', {
            receitaDespesa: '',
            description,
          });
  
          if (state.response.status === 200) {
            state.list = state.list.map((current) =>
              current.id === action.payload.response.data.id ? action.payload.response.data : current
            );
          }
        })
        .addCase(inactivateByIdAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroInativarDespesaReceita', { erro: action.error.message }),
          };
        });
    },
});

const selectError = (state) => state.aereo.error;
const selectResponse = (state) => state.aereo.response;
const selectStatus = (state) => state.aereo.status;
const selectMode = (state) => state.aereo.mode.main; 
const selectAereo = (state) => state.aereo.model;
const selectAereos = (state) => state.aereo.list;
const selectBackgroundMode = (state) => state.cliente.mode.background;
const selectSubMode = (state) => state.cliente.mode.sub;
const selectHouseType = (state) => state.aereo.type;
const selectOperationHouse = (state) => state.master.operation;

const {
    changeStatusTo,
    loading,
    success,
    failure,
    resetStatus,
    changeModeTo,
    changeToCreateMode,
    changeToConsultMode,
    changeToUpdateMode,
    resetMode,
    setHouseHawbType,
    setHouseHblType,
    resetHouseType,
    setModel,
    resetModel,
    addToList,
    updateOnList,
    resetList,
    setList,
    setResponse,
    clearResponse,
    setError,
    clearError,
    setOperationExportacao,
    setOperationImportacao,
} = houseSlice.actions;


export {
  selectError,
  selectResponse,
  selectStatus,
  selectMode,
  clearError,
  clearResponse,
  resetStatus,
  selectAereo,
  selectAereos,
  selectBackgroundMode,
  selectSubMode,
  selectHouseType,
  setModel,
  fetchAllAsync,
  fetchByIdAsync,
  setHouseHawbType,
  setHouseHblType,
  resetHouseType,
  resetMode,
  resetModel,
  addToList,
  loading,
  success,
  setError,
  failure,
  setResponse,
  changeToCreateMode,
  changeToUpdateMode,
  changeStatusTo,
  changeToConsultMode,
  changeModeTo,
  updateOnList,
  resetList,
  setList,
  setOperationExportacao,
  setOperationImportacao,
  selectOperationHouse,
}

export default houseSlice.reducer;